import { useEffect, useState } from 'react';
import { ContactCard } from '@features/contacts';
import type { ContactItem } from '@shared/types/contacts';
import {
  useContacts,
  useContactsSelecting,
  useTempContacts,
} from '../../../entities/contacts/model';
import * as st from './styles.module.scss';

interface Props {
  isSelectedList: boolean;
}

export const ContactsList: React.FC<Props> = ({ isSelectedList }) => {
  const { contacts, deleteContactById, selectedContacts, setSelectedContacts } = useContacts();
  const [viewContacts, setViewContacts] = useState<ContactItem[]>([]);
  const { tempContacts } = useTempContacts();

  const { resetSelectedContactsIds, setIsSelectingTrue, setIsSelectingFalse } =
    useContactsSelecting();

  useEffect(() => {
    if (isSelectedList) {
      resetSelectedContactsIds(selectedContacts);
      setIsSelectingTrue();
      setViewContacts(contacts);
    } else {
      const activeContacts = selectedContacts
        .map((id) => contacts.filter((cont) => cont.id === id))
        .flat();
      setViewContacts(activeContacts);
      setIsSelectingFalse();
    }
  }, [
    isSelectedList,
    selectedContacts,
    contacts,
    resetSelectedContactsIds,
    setIsSelectingTrue,
    setIsSelectingFalse,
  ]);

  const handleClickDelete = async (contactId: number) => {
    const doUnselectContact = () => {
      const updatedContacts = selectedContacts.includes(contactId)
        ? selectedContacts.filter((selectId) => selectId !== contactId)
        : [...selectedContacts, contactId];
      setSelectedContacts(updatedContacts);
    };

    if (isSelectedList) {
      await deleteContactById(contactId, doUnselectContact);
    } else {
      doUnselectContact();
    }
  };

  return (
    <>
      <ul className={st.list}>
        {viewContacts.map((contact) => (
          <li key={contact.id}>
            <ContactCard
              contact={contact}
              isSelectList={isSelectedList}
              onDelete={handleClickDelete.bind(null, contact.id)}
            />
          </li>
        ))}
        {tempContacts.map((contact) => (
          <li key={contact.id}>
            <ContactCard
              contact={{
                description: '',
                user: 0,
                base_url: '',
                formated_phone: '',
                ...contact,
              }}
              isSelectList={isSelectedList}
              onDelete={handleClickDelete.bind(null, contact.id)}
            />
          </li>
        ))}
      </ul>
    </>
  );
};
